import React, { useState } from 'react';
import './InquiryForm.css';

const InquiryForm = ({ isOpen, onClose }) => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    fullName: '',
    companyName: '',
    email: '',
    whatsapp: '',
    country: '',
    projectType: '',
    budget: '',
    timeline: '',
    description: '',
    reference: '',
    systemLink: ''
  });

  if (!isOpen) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const selectOption = (name, value) => {
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStep(3); // Move to Success Step
  };

  return (
    <div className="inquiry-overlay" onClick={onClose}>
      <div className="inquiry-modal" onClick={e => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>&times;</button>
        
        {step === 1 && (
          <div className="form-step">
            <div className="step-header">
              <span className="step-num">Step 01 / 02</span>
              <h2>Tell us about yourself</h2>
              <p>Basic information to help us connect.</p>
            </div>
            
            <form className="form-grid">
              <div className="input-group">
                <label>Full Name</label>
                <input type="text" name="fullName" placeholder="John Doe" value={formData.fullName} onChange={handleInputChange} required />
              </div>
              <div className="input-group">
                <label>Company Name</label>
                <input type="text" name="companyName" placeholder="Acme Inc." value={formData.companyName} onChange={handleInputChange} />
              </div>
              <div className="input-group">
                <label>Email Address</label>
                <input type="email" name="email" placeholder="john@company.com" value={formData.email} onChange={handleInputChange} required />
              </div>
              <div className="input-group">
                <label>WhatsApp (Optional)</label>
                <input type="text" name="whatsapp" placeholder="+1 234 567 890" value={formData.whatsapp} onChange={handleInputChange} />
              </div>
              <div className="input-group full">
                <label>Country</label>
                <input type="text" name="country" placeholder="United States" value={formData.country} onChange={handleInputChange} required />
              </div>
              
              <button type="button" className="next-btn" onClick={() => setStep(2)}>
                Next: Project Details
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </button>
            </form>
          </div>
        )}

        {step === 2 && (
          <div className="form-step">
            <div className="step-header">
              <span className="step-num" onClick={() => setStep(1)} style={{cursor: 'pointer'}}>← Back</span>
              <h2>Project Requirements</h2>
              <p>Define your vision and technical scope.</p>
            </div>
            
            <form className="form-grid" onSubmit={handleSubmit}>
              <div className="input-group full">
                <label>Project Type</label>
                <div className="option-chips">
                  {['Web App', 'SaaS', 'AI System', 'Mobile App', 'Dashboard', 'E-commerce'].map(type => (
                    <div 
                      key={type} 
                      className={`chip ${formData.projectType === type ? 'active' : ''}`}
                      onClick={() => selectOption('projectType', type)}
                    >
                      {type}
                    </div>
                  ))}
                </div>
              </div>

              <div className="input-group">
                <label>Budget Range</label>
                <select name="budget" value={formData.budget} onChange={handleInputChange} required>
                  <option value="">Select Budget</option>
                  <option value="$500–1k">$500 – $1,000</option>
                  <option value="$1k–5k">$1,000 – $5,000</option>
                  <option value="$5k+">$5,000+</option>
                </select>
              </div>

              <div className="input-group">
                <label>Timeline</label>
                <select name="timeline" value={formData.timeline} onChange={handleInputChange} required>
                  <option value="">Select Timeline</option>
                  <option value="Urgent">Urgent (ASAP)</option>
                  <option value="1 Month">1 Month</option>
                  <option value="Flexible">Flexible</option>
                </select>
              </div>

              <div className="input-group full">
                <label>Project Description</label>
                <textarea 
                  name="description" 
                  placeholder="Tell us about the problem you're solving..." 
                  value={formData.description} 
                  onChange={handleInputChange}
                  rows="4"
                  required
                ></textarea>
              </div>

              <div className="input-group">
                <label>Reference Website (Optional)</label>
                <input type="url" name="reference" placeholder="https://example.com" value={formData.reference} onChange={handleInputChange} />
              </div>

              <div className="input-group">
                <label>Existing System Link (Optional)</label>
                <input type="url" name="systemLink" placeholder="https://app.example.com" value={formData.systemLink} onChange={handleInputChange} />
              </div>
              
              <button type="submit" className="submit-btn">
                Submit Inquiry
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </button>
            </form>
          </div>
        )}

        {step === 3 && (
          <div className="success-step">
            <div className="success-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </div>
            <h2>Inquiry Received</h2>
            <div className="success-message">
              <p>Thanks for contacting <strong>Amavix Tech</strong>.</p>
              <p>Our engineering team will review your requirements and respond within <strong>24 hours</strong> via email/WhatsApp.</p>
            </div>
            <div className="next-steps">
              <h3>Next Steps:</h3>
              <ul>
                <li>Requirement analysis by our tech leads.</li>
                <li>Strategic discovery call invitation.</li>
                <li>Tailored technical proposal.</li>
              </ul>
            </div>
            <button className="close-btn-final" onClick={onClose}>Done</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default InquiryForm;
